import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class UpdateChatRemarksArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string

  @Field(() => String)
  remarks: string
}

export interface IUpdateChatRemarks extends IAction<Chat, UpdateChatRemarksArgs> {}
